<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0" v-on:keypress.enter.prevent="searchHolidays">
                    <date-picker
                            v-model="search.year"
                            lang="en"
                            type="year"
                            format="YYYY"
                            placeholder="ปี"/>
                    &nbsp&nbsp
                    <button
                            class="btn btn-success my-2 my-sm-0"
                            type="button"
                            @click="searchHolidays">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>&nbsp
                    <button @click="showHolidayModal"
                            class="btn btn-warning my-2 my-sm-0"
                            type="button">
                        <icon name="plus"></icon>
                        เพิ่มวันหยุด
                    </button>&nbsp
                </form>
            </div>
        </nav>

        <div class="col-sm-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">วันหยุด</th>
                    <th scope="col">วันที่</th>
                    <th scope="col">ผู้ตั้งค่า</th>
                    <th scope="col">แก้ไข</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in holidayList">
                    <td>{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
                    <td>{{data.name}}</td>
                    <td>{{data.start_date | moment("DD/MM/YYYY")  }}</td>
                    <td>
                        <template v-if="data.user">
                            {{data.user.name}}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <a @click="editHoliday(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                        &nbsp&nbsp
                        <a @click="showDeleteModal(data.id)">
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <!--b-modal import-->
        <b-modal hide-footer hide-header ref="holiday_import">
            <div class="text-center">
                <holiday-modal @submit="saveHoliday">
                </holiday-modal>
            </div>
        </b-modal>
        <!--b-modal delete-->
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br />
                <button type="button"
                        @click="deleteHoliday"
                        class="btn btn-success">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button type="button"
                        @click="hideDeleteModal"
                        class="btn btn-secondary">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!--<pre class="alert alert-danger">{{holidayList}}</pre>-->

        <div v-if="holidayList.length > 0">
            <vue-pagination :pagination="dataPaginate" @paginate="Pagination">
            </vue-pagination>
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import HolidayModal from "./HolidayModal";
    import VuePagination from "../../../Pagination";
    import DatePicker from 'vue2-datepicker'
    import moment from "moment";

    export default {
        components: {
            VuePagination,
            HolidayModal,
            DatePicker
        },
        name: "holidays-list",
        created(){
            this.$store.dispatch("Holiday/setHoliday");
        },
        data(){
          return {
              delete_id : "",
              search:{
                  year: ""
              }
          }
        },
        computed:{
            ...mapState({
                holidayList:state=>{
                    return state.Holiday.holidayList;
                },
                dataPaginate:state=>{
                    return state.Holiday.dataPaginate;
                }
            })
        },
        methods:{
            showHolidayModal(){
                this.$refs.holiday_import.show();
            },
            hideHolidayModal(){
                this.$refs.holiday_import.hide();
            },
            showDeleteModal(id){
                this.delete_id = id;
                this.$refs.delete_item.show();
            },
            hideDeleteModal(){
                this.$refs.delete_item.hide();
            },
            saveHoliday(submitData){
                if(submitData!=0){
                    this.$store.dispatch("Holiday/saveHoliday",submitData.id).then(()=>{
                        this.$store.dispatch("Holiday/setHoliday");
                    })
                }
                this.hideHolidayModal();
            },
            editHoliday(id){
                this.showHolidayModal();
                this.$store.dispatch("Holiday/showHolidayById",id).then(()=>{
                    this.$store.dispatch("Holiday/setHoliday");
                });
            },
            deleteHoliday(){
                this.$store.dispatch("Holiday/deleteHoliday",this.delete_id).then(()=>{
                    this.$store.dispatch("Holiday/setHoliday");
                    this.hideDeleteModal();
                });
            },
            Pagination(){
                const page = this.dataPaginate.current_page;
                this.$store.dispatch("Holiday/setHoliday",page)
            },
            searchHolidays(){
                //change year format
                if(this.search.year){
                    this.search.year = moment(this.search.year).format("YYYY");
                }else{
                    this.search.year = "";
                }

                this.$store.dispatch("Holiday/search",this.search)
            },

        }
    }
</script>

<style scoped>

</style>
